import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconOpenEye from '../../Icons/IconOpenEye/IconOpenEye';
import Tooltip from '../../Tooltip';
import PdfPagesViewerModal from './PdfPagesViewerModal';
import { toFitWidthThumbnailUrl } from './pdfViewerUrl';

const MainPdfImage = ({
  loading,
  mainScreenshot,
}: {
  loading: boolean;
  mainScreenshot: string;
}) => {
  const { t } = useTranslation();
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="border-b border-stroke px-7 py-4 dark:border-strokedark">
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-black dark:text-white">{t('labels.mainScreenshot')}</h3>
        </div>
      </div>

      <div className="p-7">
        {loading ? (
          <div className="flex items-center justify-center p-7">
            <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
          </div>
        ) : !mainScreenshot ? (
          <div className="text-gray-500 text-center text-sm">{t('labels.noMainScreenshotsFound')}</div>
        ) : (
          // Same 5-column grid as the other sections, so this card ends up
          // exactly the same size as a zoomed-screenshot/PDF card instead of
          // a hardcoded width.
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '16px', width: '100%' }}>
            <div
              key={mainScreenshot}
              className="relative cursor-pointer overflow-hidden rounded border border-strokedark bg-white"
              style={{ aspectRatio: '11 / 8.5' }}
              onClick={() => setIsViewerOpen(true)}
            >
              <iframe
                src={toFitWidthThumbnailUrl(mainScreenshot)}
                style={{
                  height: '100%',
                  width: '100%',
                  border: 'none',
                  pointerEvents: 'none',
                }}
              />
              <div className="absolute bottom-2 right-2 z-50">
                <Tooltip hint="View full screen">
                  <IconOpenEye
                    iconClassName="rounded border border-foggy-mist bg-white px-1 py-1 text-black cursor-pointer hover:bg-primary hover:text-white"
                    onClick={() => setIsViewerOpen(true)}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        )}
      </div>
      <PdfPagesViewerModal
        isVisible={isViewerOpen}
        title={t('labels.mainScreenshot')}
        pages={mainScreenshot ? [{ id: 'main-screenshot', image: mainScreenshot, isIncluded: true }] : []}
        initialPageId={null}
        onClose={() => setIsViewerOpen(false)}
        contentKind="chart"
      />
    </div>
  );
};

export default MainPdfImage;
